import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]
  static classes = ["active"]

  connect() {
    this.showTab("overview")
  }

  show(event) {
    const tabId = event.currentTarget.dataset.tabId
    this.showTab(tabId)
  }

  showTab(tabId) {
    // Hide all panels
    this.panelTargets.forEach(panel => {
      panel.classList.add("hidden")
      panel.classList.remove("block")
    })

    // Remove active state from all tabs
    this.tabTargets.forEach(tab => {
      tab.classList.remove(...this.activeClasses)
      tab.classList.add("border-transparent", "text-slate-400")
    })

    // Show the selected panel
    const selectedPanel = this.panelTargets.find(panel => 
      panel.dataset.tabId === tabId
    )
    if (selectedPanel) {
      selectedPanel.classList.remove("hidden")
      selectedPanel.classList.add("block")
    }

    // Activate the selected tab
    const selectedTab = this.tabTargets.find(tab => 
      tab.dataset.tabId === tabId
    )
    if (selectedTab) {
      selectedTab.classList.add(...this.activeClasses)
      selectedTab.classList.remove("border-transparent", "text-slate-400")
    }
  }
}